import { render, staticRenderFns } from "./RoadGantt.vue?vue&type=template&id=a3922848&scoped=true"
import script from "./RoadGantt.vue?vue&type=script&lang=js"
export * from "./RoadGantt.vue?vue&type=script&lang=js"
import style0 from "./RoadGantt.vue?vue&type=style&index=0&id=a3922848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3922848",
  null
  
)

export default component.exports